import {ActionsRow, DetailValue, FixedDropDownButton, Icon} from 'mc/lib';
import * as StavVratky from 'mc/lib/api/gen/proxioapi/StavVratky';
import * as TypVratky from 'mc/lib/api/gen/proxioapi/TypVratky';
import {formatCurrency, formatDate} from 'mc/lib/utils/commons';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {CardBlock, Col, DropdownItem, Row} from 'reactstrap';
import {stornovatVratku, tisknoutVratku} from '../../actions/platbaActions';
import * as StavVratkyInfo from '../../api/StavVratkyInfo';
import * as TypVratkyInfo from '../../api/TypVratkyInfo';
import * as appAuthActions from "../../actions/appAuthActions";
import {MODULE_CODE_POP} from "../../utils/popUtils";
import * as PopRoleUzivatele from "../../api/gen/pop/PopRoleUzivatele";
import * as authActions from "mc/lib/actions/authActions";
import {storeFromArea} from "mc/lib/utils";

class VratkaCardBlock extends PureComponent {

    static propTypes = {
        platba: PropTypes.object.isRequired,
        vratka: PropTypes.object.isRequired,
    };

    /**
     * Načtení, zda je daný uživatel ma pravo na parovani plateb.
     * @param props
     * @return {boolean}
     */
    isParovaniPlateb = (props = this.props) => {
        const {authInfo} = props;
        if (authInfo.data == null) {
            return false;
        }
        return appAuthActions.hasRole(authInfo.data, MODULE_CODE_POP, PopRoleUzivatele.POP_PAROVANI_PLATEB);
    }

    handleTisknout = () => {
        const {platba, vratka, dispatch} = this.props;
        dispatch(tisknoutVratku(platba, vratka));
    };

    handleStornovat = () => {
        const {platba, vratka, dispatch} = this.props;
        dispatch(stornovatVratku(platba, vratka));
    };

    renderActions() {
        const {vratka} = this.props;
        const items = [];
        const isParovaniPlateb = this.isParovaniPlateb();

        if (vratka.typ === TypVratky.BANKA) {
            items.push(<DropdownItem key="tisk" type="button" onClick={this.handleTisknout}>Tisknout</DropdownItem>);
        }

        if (isParovaniPlateb && vratka.stav === StavVratky.PLANOVANA) {
            items.push(<DropdownItem key="storno" type="button" onClick={this.handleStornovat}>Stornovat</DropdownItem>);
        }

        if (!items.length) {
            return null;
        }

        return (
            <FixedDropDownButton color="action" noCaret title={<Icon icon="ellipsis-v"/>}>
                {items}
            </FixedDropDownButton>
        )
    }

    render() {
        const {vratka} = this.props;
        return (
            <CardBlock>
                <ActionsRow actions={this.renderActions()}>
                    <Row>
                        <Col xs={12} sm={6} lg={3}>
                            <DetailValue label="Číslo poukazu">
                                {vratka.cisloPoukazu}
                            </DetailValue>
                        </Col>
                        <Col xs={12} sm={6} lg={3}>
                            <DetailValue label="Čáskta">
                                {formatCurrency(vratka.castka)}
                            </DetailValue>
                        </Col>
                        <Col xs={12} sm={6} lg={3}>
                            <DetailValue label="Stav">
                                {StavVratkyInfo.getCaption(vratka.stav)}
                            </DetailValue>
                        </Col>
                        <Col xs={12} sm={6} lg={3}>
                            <DetailValue label="Typ">
                                {TypVratkyInfo.getCaption(vratka.typ)}
                            </DetailValue>
                        </Col>
                        <Col xs={12} sm={6}>
                            <DetailValue label="Číslo účtu">
                                {vratka.cisloUctu}
                            </DetailValue>
                        </Col>
                        <Col xs={12} sm={6}>
                            <DetailValue label="Datum splatnosti">
                                {formatDate(vratka.datumSplatnosti)}
                            </DetailValue>
                        </Col>
                        <Col xs={12}>
                            <DetailValue label="Poznámka">
                                {vratka.poznamka}
                            </DetailValue>
                        </Col>
                    </Row>
                </ActionsRow>
            </CardBlock>
        );
    }

}

const mapStateToProps = state => ({
    authInfo: storeFromArea(state, authActions.AUTH_INFO_AREA),
});

export default connect(mapStateToProps)(VratkaCardBlock);
